import { render, staticRenderFns } from "./GridTabForm.vue?vue&type=template&id=1f2b9c6d&scoped=true&"
import script from "./GridTabForm.vue?vue&type=script&lang=js&"
export * from "./GridTabForm.vue?vue&type=script&lang=js&"
import style0 from "./GridTabForm.vue?vue&type=style&index=0&id=1f2b9c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b9c6d",
  null
  
)

export default component.exports